import { CREATE, DELETE, fetchUtils, GET_LIST, GET_ONE, UPDATE } from 'react-admin'
import { auth0, getApiUrl } from '../auth/client'
import fakeDataProvider from './fakeDataProvider'

const httpClient = async (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' })
  }
  options.headers.set('Authorization', `Bearer ${await auth0.getTokenSilently()}`)
  return fetchUtils.fetchJson(url, options)
}

const assetStatusDataProvider = async (type, resource, params) => {
  const baseApiUrl = await getApiUrl()
  if (!baseApiUrl) {
    return fakeDataProvider(type, resource, params)
  }
  const apiUrl = `${baseApiUrl}/api`

  const name = params?.data?.name ? params.data.name : ''

  switch (type) {
    case GET_LIST: {
      const { page, perPage } = params.pagination || { page: 1, perPage: 10 }
      const { field, order } = params.sort || { field: 'name', order: 'ASC' }

      const queryParams = `page=${page}&size=${perPage}&total=1&sort=${field}&order=${order}`

      const url = `${apiUrl}/asset/status?${queryParams}`
      const result = await httpClient(url).then((response) => response.json)

      const { headers, json } = await httpClient(url)

      const contentRange = headers.get('Content-Range')
      const total = contentRange ? parseInt(contentRange.split('/').pop(), 10) : json.length

      return {
        data: result.map((item) => ({ ...item, id: item.id })),
        total: total,
      }
    }

    case GET_ONE:
      const id = params.id
      const fetchedAssetStatus = await httpClient(`${apiUrl}/asset/status/${id}`).then((response) => response.json)
      return {
        data: { ...fetchedAssetStatus[0], id: fetchedAssetStatus[0].id },
      }

    case CREATE:
      return await fetch(`${apiUrl}/asset/status`, {
        method: 'post',
        body: JSON.stringify({ name }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await auth0.getTokenSilently()}`,
        },
      })
        .then((response) => response.json())
        .then((data) => ({
          data: { id: data.id, name: data.name },
        }))
        .catch((error) => {
          console.error('Error during asset creation:', error)
        })

    case UPDATE:
      return await fetch(`${apiUrl}/asset/status/${params.data.id}`, {
        method: 'put',
        body: JSON.stringify({ name }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await auth0.getTokenSilently()}`,
        },
      })
        .then((response) => response.json())
        .then((data) => ({
          data: { id: data.id, name: data.name },
        }))
        .catch((error) => {
          console.error('Error during asset update:', error)
        })

    case DELETE:
      return await fetch(`${apiUrl}/asset/status/${params.id}`, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await auth0.getTokenSilently()}`,
        },
      })
        .then(() => ({
          data: { id: params.id },
        }))
        .catch((error) => {
          console.error('Error during asset deletion:', error)
        })
    default:
      throw new Error(`Not implemented`)
  }
}

export default assetStatusDataProvider
